import { jwtDecode } from "jwt-decode";

const USERDATA_CLAIM = "https://zero13.net/userdata";
const ROLES_CLAIM = "https://zero13.net/roles";

let auth0Token = null;
let decodedToken = null;

export const setAuth0Token = (token) => {
  auth0Token = token || null;

  if (!auth0Token) {
    decodedToken = null;
    return;
  }

  try {
    decodedToken = jwtDecode(auth0Token);
  } catch (error) {
    console.error("Error decoding Auth0 token:", error);
    decodedToken = null;
  }
};

export const clearAuth0Token = () => {
  auth0Token = null;
  decodedToken = null;
};

// Authorization is not set here: both axios instances attach a freshly
// obtained token in their request interceptor, which a cached copy could not.
export const getAPIHeader = () => ({
  "Content-Type": "application/json",
});

export const getDecodedToken = () => decodedToken;

export const parseJWTDetail = (type) => {
  try {
    if (!decodedToken) return "";

    const userdata = decodedToken[USERDATA_CLAIM];

    if (!userdata) return "";

    if (type === "account") return userdata.accountid || "";
    if (type === "group") return userdata.groupid || "";

    return userdata.participantid || "";
  } catch (error) {
    console.error("Error parsing JWT detail:", error);
    return "";
  }
};

export const getUsername = () => {
  try {
    if (!decodedToken) return "";

    const userdata = decodedToken[USERDATA_CLAIM];

    return (
      userdata?.displayname ||
      decodedToken.name ||
      decodedToken.email ||
      ""
    );
  } catch (error) {
    console.error("Error retrieving username:", error);
    return "";
  }
};

export const hasUserAccess = (requiredRoles = []) => {
  try {
    if (!decodedToken) return false;

    if (
      decodedToken.exp &&
      decodedToken.exp < Math.floor(Date.now() / 1000)
    ) {
      return false;
    }

    const roles = decodedToken[ROLES_CLAIM] || [];

    return requiredRoles.some((role) => roles.includes(role));
  } catch (error) {
    console.error("Error checking user access:", error);
    return false;
  }
};

export const getRegistryFromToken = () => {
  try {
    if (!decodedToken) return "";

    return decodedToken[USERDATA_CLAIM]?.registry || "";
  } catch (error) {
    console.error("Error retrieving registry:", error);
    return "";
  }
};

export const updatePage = (prevPage, totalPages, type) => {
  if (type === "next" && prevPage < totalPages - 1) {
    return prevPage + 1;
  }

  if (type === "prev" && prevPage > 0) {
    return prevPage - 1;
  }

  return prevPage;
};